// FlexibleRespiteCareSection.js
import React from "react";
import { Phone } from "lucide-react";
import flexibleRespiteCareImage from "../assets/flexible-respite-care-image.jpg";

const FlexibleRespiteCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Flexible Respite Care to Support Family Caregivers
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                When someone you love needs care, it's only natural to want to
                handle everything yourself. But balancing caregiving with the
                demands of everyday life can take a major toll—physically,
                mentally, and emotionally. We understand how challenging that
                can be.
              </p>

              <p>
                That's why Allawah Lodge offers respite care—giving family
                caregivers a much-needed break to rest, recharge, and focus on
                their own well-being. Whether it's for a few hours or a few
                days, we're here to support you, so you can continue caring with
                strength and peace of mind.
              </p>

              <p>
                With respite care, Allawah Lodge' trained, bonded, and insured
                professionals can step in to care for your loved one—giving you
                time to recharge. Whether you need a quiet moment to rest, time
                with family, or simply a coffee break with a friend, you can
                take it with confidence knowing your loved one is in safe,
                respectful, and compassionate hands.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={flexibleRespiteCareImage}
              alt="Hand holding red heart"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexibleRespiteCareSection;
